module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    style: ({
      display: _vm.display
    })
  }, [(_vm.backLink && _vm.backLinkEnableForApp) ? _c('div', {
    staticClass: "c-menu__link",
    on: {
      "click": function($event) {
        _vm.handleBackClick()
      }
    }
  }, [_c('div', {
    staticClass: "bk-menu-icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.showMenu) ? _c('side-menu', {
    attrs: {
      "backButtonOnLeft": _vm.backLink && _vm.backLinkEnableForApp
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLogo),
      expression: "showLogo"
    }],
    staticClass: "ge-logo"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-732c3061"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheTopNavSection.vue
// module id = 230
// module chunks = 1